import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const overrideYupTypeError = (errorObject: any, key: string) => {
  if (!errorObject) return;
  if (!errorObject[key]) return;
  return <p>{errorObject[key]}</p>;
};

export default overrideYupTypeError;
